import ApiService from '@/app/framework/services/ApiServices'
import { Endpoints } from '@/app/framework/misc/Endpoints'
import { injectable } from 'tsyringe'
import { NotificationReportRepositoryInterface } from '@/data/persistences/repositories/contracts/NotificationReportRepositoryInterface'
import { NotificationReport } from '@/domain/entities/NotificationReports'
import { NotificationReportDataMapper } from '@/data/persistences/mappers/NotificationReportDataMapper'

@injectable()
export class NotificationReportApiRepository
  implements NotificationReportRepositoryInterface {
  private service: ApiService
  private mapper: NotificationReportDataMapper

  constructor(service: ApiService, mapper: NotificationReportDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getAll(params: Object): Promise<NotificationReport> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.REPORT_NOTIFICATION,
      params
    )
    return this.mapper.convertNotificationReportFromApi(resp)
  }
  // public async getExport(params: Object): Promise<Export> {
  //   const resp = await this.service.invoke(
  //     'get',
  //     Endpoints.Route.EXPORT_INFO,
  //     params
  //   )
  //   return this.mapper.convertExportFileFromAPi(resp)
  // }
}
